import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=96fdf8b4&scoped=true&lang=pug&"
import script from "./searchBar.vue?vue&type=script&lang=ts&"
export * from "./searchBar.vue?vue&type=script&lang=ts&"
import style0 from "./searchBar.vue?vue&type=style&index=0&id=96fdf8b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fdf8b4",
  null
  
)

export default component.exports